import { Badge } from 'react-daisyui';
import { twMerge } from 'tailwind-merge'

const StatusBadge = ({ status, className = '', icon = null }) => {
  const Icon = icon;
  return (
    <Badge className={twMerge(`text-xs font-semibold border border-transparent flex items-center gap-1`, className)}>
      {Icon && <Icon size={12} />}
      {status}
    </Badge>
  )
}

export default StatusBadge;
